<template>
  <base-modal
    :size="'xl'"
    :modalId="'image-preview-fullscreen'"
    :bindValue="bindValue"
    hideHeader
    hideFooter
    noFade
    @hidden="$emit('closeModal')"
  >
    <div
      class="d-flex flex-column justify-content-center"
      v-if="imageUrl"
      @click="clickContent"
    >
      <img
        :src="imageUrl"
        class="m-auto image-fullscreen-content image-preview"
        :style="{
          transform: 'rotate(' + rotateImage + 'deg)',
        }"
        draggable="false"
        alt=""
      />
    </div>
  </base-modal>
</template>

<script>
import BaseModal from "@/@core/components/base-modal/BaseModal.vue";
import { computed, getCurrentInstance } from "vue-demi";
export default {
  components: { BaseModal },
  props: {
    imageUrl: String,
    bindValue: { type: Boolean, default: false },
    rotate: Number,
  },
  setup(props) {
    const vm = getCurrentInstance().proxy;
    const rotateImage = computed(() => {
      return props.rotate || 0;
    });

    const clickContent = (e) => {
      if (e.target.tagName == "DIV") vm.$emit("closeModal");
    };

    return {
      rotateImage,
      clickContent,
    };
  },
};
</script>

<style>
#image-preview-fullscreen .modal-dialog .modal-content {
  background: transparent;
  width: fit-content;
  margin: auto;
  box-shadow: none;
  width: 100%;
  height: 100%;
}

#image-preview-fullscreen .modal-dialog .modal-content .modal-body {
  padding: 0;
}

#image-preview-fullscreen {
  transform: scale(0);
  transition: transform 0.2s ease-out;
}

#image-preview-fullscreen.modal.show {
  transform: scale(1) !important;
  transition: transform 0.4s ease-out;
}

#image-preview-fullscreen .image-preview {
  width: 350px;
  height: auto;
}
</style>
